import { TicketTaskResult } from "./ticket-task-result";

export class TicketTaskResultForEmployeeBoard {
    public assignedEmployeeId: number = 0;
    public assignedEmployeeFullName: string = '';
    public ticketTasks = new Array<TicketTaskResult>();
}
